module.exports = __webpack_public_path__ + "files/d064433556241598b869aba015ceee9b.png";